import logomain from "../../../images/logo-main.png";
import "../../../css/pages/login.css";
import { Link, useNavigate } from "react-router-dom";
import { LoginFunction } from "./LoginFunction";
import { useState } from "react";
import { LoadPanel, Toast } from "devextreme-react";
import Cookies from "js-cookie";

export const Login = () => {
  const navigation = useNavigate();
  const clas = new LoginFunction();
  const [isEyeOpen, setIsEyeOpen] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [email, setemail] = useState(
    Cookies.get("username") && Cookies.get("username") !== "undefined"
      ? Cookies.get("username")
      : ""
  );
  const [validation, setvalidation] = useState("");
  const [password, setpassword] = useState(
    Cookies.get("password") && Cookies.get("password") !== "undefined"
      ? Cookies.get("password")
      : ""
  );
  const [rememberMe, setRememberMe] = useState(
    Cookies.get("username") ? true : false
  );

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;

  function isPasswordValid(passwords) {
    return passwordRegex.test(passwords);
  }

  const Login = () => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    if (!emailPattern.test(email.trim())) {
      setvalidation(clas.ErrorValidationConstant);
      return;
    }

    if (!isPasswordValid(password.trim())) {
      setvalidation(clas.ErrorValidationConstant);
      return;
    }

    if (email.trim() && password.trim()) {
      setvalidation("");
      clas.Login(
        {
          email: email,
          password: password,
          loginType: 1,
          userType: "admin",
          deviceType: 3,
          deviceToken: "abcd",
          deviceId: "abcd",
        },
        setvalidation,
        setToastConfig,
        toastConfig,
        rememberMe,
        Cookies,
        navigation,
        setLoading
      );
    } else {
      setvalidation(clas.ErrorValidationConstant);
    }
  };

  const RememberMe = () => {
    setRememberMe(!rememberMe);
    rememberMe && Cookies.remove("username");
    rememberMe && Cookies.remove("password");
  };

  function togglePwd() {
    setIsEyeOpen(!isEyeOpen);
  }

  return (
    <>
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        position={"top"}
        width={"auto"}
      />
      <section className="login">
        <div className="container">
          <div className="login__flex">
            <div className="login__item login__item--img" />
            <div className="login__item login__item--form">
              <div className="branding">
                <div className="branding__logo">
                  <img
                    src={logomain}
                    alt="Logo | Welcome To UPA"
                    className="branding__logo__img"
                  />
                </div>
                <div className="branding__info">
                  <h1 className="title title--h1">Login to your Account</h1>
                  <p className="text">Manage your apps here!</p>
                </div>
              </div>
              <div className="login__form">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      Login();
                      e.preventDefault();
                    }
                  }}
                >
                  <div className="form__group">
                    <label htmlFor="email" className="form__label">
                      Email
                    </label>
                    <input
                      type="email"
                      style={{ border: validation ? "2px solid red" : "" }}
                      id="email"
                      className="form-control"
                      placeholder="Enter Email"
                      value={email}
                      onChange={(e) => {
                        setemail(e.target.value);
                        setvalidation("");
                      }}
                    />
                  </div>
                  <div className="form__group">
                    <label htmlFor="password" className="form__label">
                      Password
                    </label>
                    <div className="form__paswordfield">
                      <input
                        type={isEyeOpen ? "text" : "password"}
                        id="password"
                        className="form-control"
                        placeholder="Password"
                        value={password}
                        style={{ border: validation ? "2px solid red" : "" }}
                        onChange={(e) => {
                          setpassword(e.target.value);
                          setvalidation("");
                        }}
                      />
                      <button
                        onClick={togglePwd}
                        className={`eyebtn ${!isEyeOpen ? " " : " eyeopen"}`}
                      />
                    </div>
                  </div>
                </form>
                {validation && (
                  <p className="field-error" style={{ marginTop: "-15px" }}>
                    {validation}
                  </p>
                )}
                <div className="form__flexrow">
                  <div className="form__group">
                    <div className="form__checkbox">
                      <input
                        type="checkbox"
                        id="remember"
                        className="form__checkbox"
                        onChange={() => {
                          RememberMe();
                        }}
                        checked={rememberMe}
                      /> 
                      <label
                        htmlFor="remember"
                        className="label label--checkbox"
                      >
                        Remember me!
                      </label>
                    </div>
                  </div>
                  <div className="form__group">
                    <p className="para para--right">
                      <Link
                        onClick={() => {
                          navigation("/forgot-password");
                        }}
                        className="link"
                        style={{ cursor: "pointer" }}
                      >
                        Forgot Password?
                      </Link>
                    </p>
                  </div>
                </div>
                <div className="form__group">
                  <button
                    className="btn btn--primary btn--full"
                    onClick={() => {
                      Login();
                    }}
                  >
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
